import React from "react";
import PropTypes from "prop-types";

import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const Modal = ({
  children,
  open,
  onClose,
  maxWidth,
  header,
  showCloseButton,
  closeButton,
  actions,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby={`${header}-dialog-title`}
      fullWidth
      maxWidth={maxWidth}
    >
      <DialogTitle id={`${header}-dialog-title`}>
        {header}
        {showCloseButton && (
          <>
            {closeButton || (
              <Box position="absolute" right="10px" top="5px">
                <IconButton aria-label="close" onClick={onClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
            )}
          </>
        )}
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
};

Modal.defaultProps = {
  open: false,
  maxWidth: "sm",
  showCloseButton: true,
  closeButton: null,
  actions: null,
};

Modal.propTypes = {
  children: PropTypes.objectOf(PropTypes.any).isRequired,
  closeButton: PropTypes.objectOf(PropTypes.any),
  actions: PropTypes.objectOf(PropTypes.any),
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool,
  maxWidth: PropTypes.string,
  header: PropTypes.string.isRequired,
  showCloseButton: PropTypes.bool,
};

export default Modal;
